//Initialize Foundation
$(document).foundation();

// placeholder laten werken in oudere browsers
if(!Modernizr.input.placeholder) {
	$("input").each(
	function() {
		if($(this).attr("placeholder")!="") {
			if($(this).val()=="")
				$(this).val($(this).attr("placeholder"));
			$(this).focus(function() {
				if($(this).val()==$(this).attr("placeholder")) 
					$(this).val("");
			});
			$(this).blur(function() {
				if($(this).val()=="") 
					$(this).val($(this).attr("placeholder"));
			});
		}
	});
}

(function($) {
	$.fn.equalHeights = function() {
		var max = 0;
		this.each(function() {
			if($(this).height() > max) {
				max = $(this).height();
			}
		});
		return this.each(function() {
			$(this).height(max);
		});
	}
})(jQuery);

$(function() {
	if($(window).width() >= 768) {
		$('.equal1').equalHeights();
		$('.equal2').equalHeights();
		$('.equal3').equalHeights();
	}
});

// Polyfill for CSS object fit
Modernizr.addTest('object-fit',
  !!Modernizr.prefixed('objectFit')
);

if ($('html').hasClass('no-object-fit')) {
  $('.slider .imagecontainer, .blokjes a').each(function () {
    var $container = $(this),
      imgUrl = $container.find('img').attr('src');
    if (imgUrl) {
      $container
        .css('backgroundImage', 'url(' + imgUrl + ')');
    }
  });
}
